import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const CARGO_ANALISTA_DE_PROJETOS: MapaCargo = 
{
  id: 'analista-de-projetos',
  titulo: 'Analista de Projetos',
  setor: 'Projetos',
  secoes: [
    {
      id: 'responsabilidades',
      titulo: 'Responsabilidades',
      atividades: [
        'Atendimento ao cliente desde o início do projeto;',
        'Acompanhamento junto ao cliente de etapas com parceiros;',
        'Configurações dentro de plataformas de e-commerce;',
        'Condução de reuniões junto ao cliente e parceiros;',
        'Criação e gerenciamento de cronogramas;',
        'Reuniões internas para alinhamentos;',
        'Envio de Status Report dos projetos;',
        'Acompanhamento de chamados e seus respectivos prazos.',
      ],
    },
  ],
}
